export default "__VITE_ASSET__DwSoNHRR__"